import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const MobileBottomDrawer = styled(Grid)({
  position: "fixed",
  bottom: "calc(64px + env(safe-area-inset-bottom))",
  left: 0,
  width: "100vw",
  justifyContent: "center",
  display: "flex",
  backgroundColor: "white",
  paddingBottom: "8px",
  paddingTop: "8px",
  paddingLeft: "16px",
  paddingRight: "16px",
  boxSizing: "border-box",
  zIndex: 1301, // Above MUI Dialog (1300) to ensure visibility
  boxShadow: "0 -2px 8px rgba(0,0,0,0.1)", // Add shadow for visibility
});

export const MobileTopHintContainer = styled(Grid)({
  position: "fixed",
  top: 0,
  width: "100vw",
  justifyContent: "center",
  display: "flex",
  backgroundColor: "transparent",
});

export const VerticalCenterContainer = styled("div")({
  position: "relative",
  top: "50%",
});

export const MobileButtonGroup = styled("div")(({ theme }) => ({
  position: "relative",
  right: theme.spacing(1), // NB: different from desktop
  paddingTop: theme.spacing(1), // NB: different from desktop
  paddingBottom: theme.spacing(1), // NB: different from desktop
}));
